import { render, staticRenderFns } from "./UserNoticeList.vue?vue&type=template&id=fffee578&"
import script from "./UserNoticeList.vue?vue&type=script&lang=js&"
export * from "./UserNoticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideXTransition})
